<section id="retirement-plans">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>IFC Target Retirement Index Portfolios Performance</h1>
      </div>
    </div>
  </div>
</section>

<section class="section">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <p><a [routerLink]="['/portfolios/target-date']">&laquo; Back to Target Retirement Index Portfolios</a></p>

        <h2>Glide Path</h2>
        <p>Each portfolio's mix of underlying funds shifts from equity toward fixed income as its target retirement year approaches. The chart below shows the current allocation of each vintage, from the most aggressive (2080) to the most conservative (Retirement Income).</p>
        <app-glide-path-chart class="d-block mb-4"></app-glide-path-chart>

        <h2>Performance</h2>
        <p>Annualized returns for each IFC Target Retirement Index Portfolio, net of IFC&rsquo;s advisory fee schedule for your starting investment amount. The table updates automatically as new monthly performance data becomes available.</p>

        <form class="row g-2 align-items-end mb-3" (ngSubmit)="recalculateReturns()">
          <div class="col-auto">
            <label for="starting-assets" class="form-label mb-1">Starting Investment</label>
            <div class="input-group">
              <span class="input-group-text">$</span>
              <input id="starting-assets" name="startingAssets" type="text" inputmode="numeric" class="form-control"
                [(ngModel)]="startingAssets" mask="separator.0" thousandSeparator="," placeholder="100,000"
                style="max-width:10rem">
            </div>
          </div>
          <div class="col-auto">
            <button type="submit" class="btn btn-primary" [disabled]="returnsLoading()">
              @if (returnsLoading()) { Updating&hellip; } @else { Update }
            </button>
          </div>
        </form>

        @if (returnsLoading()) {
          <p class="text-muted">Loading performance data&hellip;</p>
        }
        @if (returnsError()) {
          <p class="text-muted">{{ returnsError() }}</p>
        }
        @if (!returnsError() && returnRows().length) {
          <div class="table-responsive mb-3">
            <table class="table table-sm table-bordered table-hover table-striped align-middle mb-0">
              <thead class="table-light">
                <tr>
                  <th style="white-space:nowrap">Investment</th>
                  @for (period of returnPeriods(); track period.label) {
                    <th class="text-end">
                      {{ period.label }}
                      <div class="text-muted fw-normal" style="font-size:.8em;">
                        {{ period.startDate | date:'M/d/yyyy' }} &ndash; {{ period.endDate | date:'M/d/yyyy' }}
                      </div>
                    </th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (row of returnRows(); track row.symbol) {
                  <tr>
                    <td class="text-nowrap">{{ row.name }}</td>
                    @for (cell of row.cells; track $index) {
                      <td class="text-end">
                        @if (cell) {
                          @if (cell.months >= 12) {
                            <span [title]="(cell.annualizedReturn | number:'1.2-5') + '%'">{{ cell.annualizedReturn | number:'1.2-2' }}%</span>
                          } @else {
                            <span [title]="(cell.totalReturn | number:'1.2-5') + '%'">{{ cell.totalReturn | number:'1.2-2' }}%</span>
                          }
                        } @else {
                          &mdash;
                        }
                      </td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </div>
          <p><small>Returns over one year are annualized. Model portfolio performance is hypothetical backtested performance, net of IFC’s advisory fee schedule for the starting investment amount entered above and underlying fund expenses, and does not represent actual client returns. Past performance does not guarantee future results. See important disclosures at <a href="http://ifcdisclosures.com">ifcdisclosures.com</a>.</small></p>
          <p><a [routerLink]="['/index-calculator']" [queryParams]="calculatorQueryParams">Explore these portfolios in the Index Calculator &raquo;</a></p>
        }

        @if (fundDescriptions().length) {
          <div class="mt-4">
            <h2>Fund Descriptions</h2>
            <div class="table-responsive mb-4">
              <table class="table table-sm table-bordered mb-0">
                <thead class="table-light">
                  <tr>
                    <th>Fund</th>
                    <th>Description</th>
                    <th class="text-center">Equity Range</th>
                  </tr>
                </thead>
                <tbody>
                  @for (f of fundDescriptions(); track f.symbol) {
                    <tr>
                      <td style="min-width:200px">{{ f.name }}</td>
                      <td [innerHTML]="f.description | safe:'html'" style="font-size:.85em"></td>
                      <td class="text-center" style="white-space:nowrap">
                        @if (f.equityMin !== null && f.equityMax !== null) {
                          @if (f.equityMin === f.equityMax) { {{ f.equityMin }}% }
                          @else { {{ f.equityMax }}% &ndash; {{ f.equityMin }}% }
                        } @else {
                          <span class="text-muted">&mdash;</span>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }

        <hr>
        <app-important-disclosures></app-important-disclosures>
      </div>
    </div>
  </div>
</section>
